import { useState } from 'react';
import { Risco } from '../types';

export function useModalState(parte: string, descricaoMaquina: string) {
  const [salvando, setSalvando] = useState(false);
  const [nomeParte, setNomeParte] = useState<string>(parte);
  const [fotoParte1, setFotoParte1] = useState<string>('');
  const [fotoParte2, setFotoParte2] = useState<string>('');
  const [fotoParte3, setFotoParte3] = useState<string>('');
  const [fotoParte4, setFotoParte4] = useState<string>('');
  const [ciclosVida, setCiclosVida] = useState<string[]>([]);
  const [novoCicloVida, setNovoCicloVida] = useState('');
  const [eventoPerigoso, setEventoPerigoso] = useState('');
  const [conforme, setConforme] = useState<boolean>(true);
  const [tiposPerigoSelecionados, setTiposPerigoSelecionados] = useState<string[]>([]);
  const [perigosEncontrados, setPerigosEncontrados] = useState<string[]>([]);
  const [potenciaisConsequencias, setPotenciaisConsequencias] = useState<string[]>([]);
  const [potenciaisConsequenciasEspecificas, setPotenciaisConsequenciasEspecificas] = useState<string[]>([]);
  const [origemEspecifica, setOrigemEspecifica] = useState<string[]>([]);
  const [descricaoCondicaoAtual, setDescricaoCondicaoAtual] = useState<string[]>([]);
  const [pendingDescricao, setPendingDescricao] = useState('');
  const [medidasControle, setMedidasControle] = useState<string[]>([]);
  const [pendingMedida, setPendingMedida] = useState('');
  const [exigenciasNormativas, setExigenciasNormativas] = useState<string[]>([]);
  const [pendingExigencia, setPendingExigencia] = useState('');
  const [adequacoesNormativas, setAdequacoesNormativas] = useState<string[]>([]);
  const [pendingAdequacao, setPendingAdequacao] = useState('');
  const [pronta, setPronta] = useState(false);
  const [riscosEditados, setRiscosEditados] = useState<Risco[]>([]);
  const [partesCorpoAtingidas, setPartesCorpoAtingidas] = useState<string>('Corpo inteiro');

  // Estados para análise de IA
  const [analisandoIA, setAnalisandoIA] = useState(false);
  const [mostrarDialogIA, setMostrarDialogIA] = useState(false);
  const [descricaoMaquinaIA, setDescricaoMaquinaIA] = useState(descricaoMaquina);

  // Estado para exibir ou ocultar HRN/SRP no documento
  const [exibirHRN, setExibirHRN] = useState(true);
  const [exibirSRPCS, setExibirSRPCS] = useState(true);

  return {
    salvando,
    setSalvando,
    nomeParte,
    setNomeParte,
    fotoParte1,
    setFotoParte1,
    fotoParte2,
    setFotoParte2,
    fotoParte3,
    setFotoParte3,
    fotoParte4,
    setFotoParte4,
    ciclosVida,
    setCiclosVida,
    novoCicloVida,
    setNovoCicloVida,
    eventoPerigoso,
    setEventoPerigoso,
    conforme,
    setConforme,
    tiposPerigoSelecionados,
    setTiposPerigoSelecionados,
    perigosEncontrados,
    setPerigosEncontrados,
    potenciaisConsequencias,
    setPotenciaisConsequencias,
    potenciaisConsequenciasEspecificas,
    setPotenciaisConsequenciasEspecificas,
    origemEspecifica,
    setOrigemEspecifica,
    descricaoCondicaoAtual,
    setDescricaoCondicaoAtual,
    pendingDescricao,
    setPendingDescricao,
    medidasControle,
    setMedidasControle,
    pendingMedida,
    setPendingMedida,
    exigenciasNormativas,
    setExigenciasNormativas,
    pendingExigencia,
    setPendingExigencia,
    adequacoesNormativas,
    setAdequacoesNormativas,
    pendingAdequacao,
    setPendingAdequacao,
    pronta,
    setPronta,
    riscosEditados,
    setRiscosEditados,
    partesCorpoAtingidas,
    setPartesCorpoAtingidas,
    analisandoIA,
    setAnalisandoIA,
    mostrarDialogIA,
    setMostrarDialogIA,
    descricaoMaquinaIA,
    setDescricaoMaquinaIA,
    exibirHRN,
    setExibirHRN,
    exibirSRPCS,
    setExibirSRPCS,
  };
}

